// extracted by mini-css-extract-plugin
export default {"barChartWrapper":"BarChart_barChartWrapper__VRCIJ"};